// extracted by mini-css-extract-plugin
export default {"section":"stack-report-section_section__F3OD9","tableContainer":"stack-report-section_tableContainer__dcb1X"};